<template>
  <div class="app-wrapp">
    <section class="bg-clay">
        <div class="article-head article-head--a4">
          <div class="article-head__img article-head__img--a4 img-w animated fadeInLeft">
            <img src="@/assets/img/article4/img1.png" alt="">
          </div>
          <h2 class="article-head__title article-head__title--a4">
            <div class="animated fadeInRight" style="opacity: 0;">
              {{ 'Миллионы россиян боялись потерять свои гаражи. Почему теперь такой опасности нет?' | typograf }}
            </div>
            <div class="article-head__line2 img-w">
              <img src="@/assets/img/article2/line1.png" alt="">
            </div>
            <div class="mobile-visible article-head__line article-head__line--a4 img-w">
              <img src="@/assets/img/article1/line1.png" alt="">
            </div>
          </h2>
        </div>
    </section>

    <section class="article-text bg-clay article-text--pre-blue">
      <div class="article-wrapper">
        <h3 class="article-text__h3" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Подвал обвалился, а крыша текла»' | typograf }}
        </h3>
        <p class="article-text__subtitle" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Если спросить европейца о том, что такое гараж, он удивленно пожмет плечами: это место, где стоит его автомобиль. Даже американец из глубинки, у которого наверняка в гараже есть небольшая мастерская, скажет, что гараж — он и есть гараж. Но для любого россиянина эта нехитрая хозяйственная постройка десятилетиями имела поистине сакральное значение.' | typograf }}
        </p>
      </div>
      <div class="article-text__shifted-box">
        <div class="article__img article__img3 img-w" v-animate-onscroll="'animated fadeInRight'">
          <img src="@/assets/img/article4/img2.png" alt="">
        </div>
        <div class="article__line article__line2 img-w" style="opacity: 0;" v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article4/line2.png" alt="">
        </div>
        <div class="article-wrapper article-wrapper--shifted-r">
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Оно и понятно — гараж для мужчины советского времени был не просто местом, где можно повозиться со своим детищем отечественного автопрома, но и помещением для посиделок с друзьями.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Не зря Эльдар Рязанов снял одноименный фильм, целиком посвященный заседанию гаражного кооператива, на котором решается, кто достоин получить в нем место, а кто нет.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'А уж как любили гаражи дети! Эти воспоминания уже почти скрыты пеленой времени, но иногда нет-нет да и всплывет из глубин сознания тот день, когда папа нехотя соглашался взять тебя в этот храм взрослой жизни, за воротами которого всегда прохладно и пахнет бензином, маслом и сыростью, а каждый уголок таит в себе новые открытия…' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Но на протяжении последних лет россияне были уверены: гаражная культура неизбежно исчезнет, как и сами гаражи.' | typograf }}
          </p>
          <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[0]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Потерять гараж боялся и москвич Алексей Рогов. Этот страх преследовал его несколько лет. На его глазах уходила целая эпоха, воспоминания о детстве, память о близких.' | typograf }}
          </p>
        </div>
      </div>
      <div class="article-wrapper">
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'В этом самом гараже он проводил время с дедом, у которого была легендарная «копейка» 1972 года выпуска. Каждый раз, когда их на дороге обгонял очередной ЗАЗ, дедушка хмурился и со словами «Что это, меня еще и “запорожцы” обгонять будут?» прибавлял газа. «Копейка» была привычной, а вот ЗАЗ тарахтел, словно мотоцикл, и маленький Леша думал: вот он, идеальный автомобиль. И, конечно же, представлял, как он обгоняет деда на этом легендарном детище советского автопрома.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'В 2015 году его мечта сбылась. Он наконец обзавелся стареньким «запорожцем».' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Увы, обогнать на нем деда было уже не суждено.' | typograf }}
        </p>
      </div>
      <div class="article-text__shifted-box">
        <div class="article__img article__img4 img-w" v-animate-onscroll="'animated fadeInLeft'">
          <img src="@/assets/img/article4/img3.png" alt="">
        </div>
        <div class="article__line article__line3 img-w" v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article4/line3.png" alt="">
        </div>
        <div class="article-wrapper article-wrapper--shifted">
          <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[1]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Дед всегда говорил Алексею: «Леха, гараж тебе останется, будешь тут своими делами заниматься».' | typograf }}
          </p>
          <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote-black.png" alt="">
            </div>
            {{ '«Бабушка так и поступила — оставила его мне со словами, что раз дед так говорил — значит, так и будет», — вспоминает москвич, который очень хочет сохранить свой гараж. ' | typograf }}
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Хотя первое время у него были большие сомнения относительно судьбы этой постройки.' | typograf }}
          </p>
          <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote-black.png" alt="">
            </div>
            {{ '«Гаражом не сильно занимались, потому что документов на него никаких нет, а значит, капитально в него вкладываться было странно. Подвал обвалился, крыша текла, но зачем все это чинить, если не чувствуешь помещение своим?» — объясняет Алексей.' | typograf }}
          </div>
          <div class="article-text__quote article-text__quote--nm" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[2]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
        </div>
      </div>
      <div class="article-wrapper article-wrapper--mob-m">
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ '«В России эта проблема возникла уже давно», — говорит глава Всероссийского общества автомобилистов Валерий Солодунов. Дело в том, что те земельные участки, которые выделялись под эти гаражи, являются как бы бесхозными. Никто не платит налог на землю, и люди, которые хотели получить ее в собственность, не могли этого сделать, потому что и документы, которые говорили о том, что эта земля сдана в аренду, были утрачены, а значит, и проблемы при регистрации возникали из-за отсутствия какой-то отправной точки.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Поэтому в стране было очень много неучтенных гаражей.' | typograf }}
        </p>
        <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[3]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Прежде всего, говорит он, спорно было даже хранение того же самого автомобиля на объекте, который как бы никому нигде и никак не принадлежит. Ведь о том, что у него есть владелец, никаких сведений просто не было.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Поэтому с точки зрения законодательства хранить свое транспортное средство там он не имел права. А если и имел, то должен был платить за землю, на которой расположен этот гараж. «Чего, собственно, практически ни один автовладелец не делал», — констатирует Солодунов. По его словам, в большинстве случаев гаражи образовывали стихийно созданные островки, зачастую без охраны: «Просто стояли какие-то строения, и там, помимо автомобилей, хранилось что попало».' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Как отмечает Солодунов, эта проблема в основном возникала в небольших населенных пунктах. Дело в том, что в Москве и Петербурге все же большинство гаражей находятся в составе либо кооперативов, либо товариществ — первичных организаций. «Но, конечно, и в Петербурге, и в Москве были неучтенные гаражи — мало, но они все равно и сейчас есть. Навести в этой области порядок сам бог велел», — говорит эксперт.' | typograf }}
        </p>
        <Loading :class="{'is-loading-animated': isLoading}" />
        <div class="observer-move"></div>
        <Layers />
      </div>
    </section>

    <section id="element-container" class="article-text article-text--blue article-text--blue1 -no-blue">
      <div id="element-content">

        <div class="article-wrapper article-wrapper--mt article-wrapper--inner">
          <h3 id="element" class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
            {{ '«Это настоящий прорыв для людей»' | typograf }}
          </h3>
          <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
            {{ 'По словам главы Росреестра Олега Скуфинского, до недавнего времени для оформления собственности на такой гараж человеку приходилось доказывать свои права на него в суде, тратя на это порядка 50 тысяч рублей. К счастью, с 1 сентября 2021 года все будет по-другому.' | typograf }}
          </p>
        </div>
        <div class="article-text__shifted-box">
          <div class="article__img article__img5 img-w"  v-animate-onscroll="'animated fadeInRight'">
            <img src="@/assets/img/article4/img4.png" alt="">
          </div>
          <div class="article__line article__line4 img-w"  v-animate-onscroll="'animated fadeInLeft'">
            <img src="@/assets/img/article4/line4.png" alt="">
          </div>
          <div class="article-wrapper article-wrapper--inner article-wrapper--shifted-right">
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'С этого дня в стране стартует «гаражная амнистия», которая избавит россиян от подобных проблем. Закон, разработанный думской фракцией «Единой России», позволяет существенно упростить регистрацию капитальных гаражей, построенных до 2005 года, когда в силу вступил действующий Градостроительный кодекс, и земли под этими гаражами.' | typograf }}
            </p>
            <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[4]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
            </div>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ '«Принятие федерального закона о приватизации не только гаражей, не только самих строений, но и земли под ними, — это настоящий прорыв для людей», — говорит Валерий Солодунов. Теперь, по его словам, можно спокойно оформить в собственность и гараж, и землю, и в законном порядке распоряжаться ею: подарить, продать и так далее. «Гараж становится объектом собственности. И эта инициатива была выдвинута как нельзя более своевременно», — отмечает глава Всероссийского общества автомобилистов.' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Как говорит Солодунов, с вступлением в силу закона о «гаражной амнистии» автомобилисту не надо доказывать, что он  построил гараж или кто-то ему это строение передал. «Ты идешь и оформляешь этот земельный участок, на котором стоит гараж, в свою собственность, — рассказывает эксперт. — Вместе с ним, конечно, кроме прав ты приобретаешь и обязанности». За землю придется платить налоги — «что логично, так как об этом говорит законодательство». ' | typograf }}
            </p>
          </div>
        </div>
        <div class="article-wrapper article-wrapper--mt article-wrapper--inner article-wrapper--pb">
          <div class="article-text__quote article-text__quote--blue-nm" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[5]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Зарегистрировать право на гараж, доставшийся ему от деда, намерен и Алексей Рогов. После этого он намерен сделать в нем капитальный ремонт и убрать оттуда весь хлам. «А дальше уже с сыном будем там заниматься делами, купим какую-нибудь ретро-машину с чистыми документами — другой “запорожец” или “копейку”», — уже строит планы Алексей. Он признается, что если бы не «гаражная амнистия», гараж так и продолжали бы использовать как хозблок.' | typograf }}
          </p>
        </div>
      </div>
    </section>

    <section class="article-text">
      <div class="article-wrapper article-wrapper--mt3">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Люди смогут все легализовать быстро и качественно»' | typograf }}
        </h3>
        <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
          {{ 'По словам Солодунова, точной оценки количества гаражей, подпадающих под действие закона, нет, однако их число «существенно превышает миллион».' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Сильно спешить с регистрацией не обязательно, но и медлить не стоит, ведь «гаражная амнистия» продлится пять лет — до 2026 года.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Как отмечал 4 августа 2021 года премьер-министр России Михаил Мишустин, теперь «те, кто много лет имел такое неоформленное строение, смогут все это легализовать, и сделать это быстро и качественно».' | typograf }}
        </p>
      </div>
      <div class="article-text__shifted-box">
        <div class="article__img article__img8 img-w" v-animate-onscroll="'animated fadeInRight'">
          <img src="@/assets/img/article4/img5.png" alt="">
        </div>
        <div class="article__line article__line3 img-w"  v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article4/line3-blue.png" alt="">
        </div>
        <div class="article-wrapper article-wrapper--shifted">
          <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[6]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Гражданин должен написать заявление, подать его в Росреестр (в том числе через МФЦ) или администрацию населенного пункта, и по праву подачи документов в одно окно ему обязаны зарегистрировать участок, на котором расположен гараж, и оформить его в собственность без затраты средств и времени. Госпошлину платить не нужно, достаточно предъявить абсолютно любой документ, подтверждающий постройку гаража. «Закон говорит именно об этом, никаких сложных моментов в нем нет», — поясняет Солодунов.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Для подтверждения права собственности на гараж, находящийся в составе какого-либо объединения, гражданин обязан взять справку от товарищества или другого образования, где это строение находится. В справке должно быть указано, что он является членом этого кооператива и исправно платит за этот гараж взносы.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Глава Росреестра Олег Скуфинский подтвердил, что ведомство в полной мере готово приступить к реализации закона, уже провело инвентаризацию всех гаражей совместно с регионами и готово «сопровождать каждую сделку». Для этого с руководством каждого региона страны Росреестр подписал дорожную карту действий. Главам регионов также дана рекомендация ограничить стоимость кадастровых работ по гаражам.' | typograf }}
          </p>
        </div>
      </div>
      <div class="article-wrapper">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Что нужно знать о «гаражной амнистии»?' | typograf }}
        </h3>
      </div>
    </section>

    <div class="info">
      <h3 class="info__title info__title--blue">
        {{ '«Гаражная амнистия» продлится до 2026 года' | typograf }}
      </h3>
      <div class="info__columns">
        <div class="info__column--35">
          <div class="info__amount info__amount--a5">
            > 6 млн.
          </div>
          <div class="info__column-title">
            гаражей в россии
          </div>
        </div>
        <div class="info__column--65">
          <h3 class="info__title info__title--column">
            {{ 'Каких гаражей коснется «амнистия»?' | typograf }}
          </h3>
          <ul class="info__list info__list--a4">
            <li>— капитальных</li>
            <li>— построенных до 2005 года</li>
            <li>— не являющихся самовольной постройкой</li>
          </ul>
        </div>
      </div>
      <div class="info__columns">
        <div class="info__column--35">
          <div class="info__amount info__amount--a5">
            > 1 млн.
          </div>
          <div class="info__column-title">
            гаражей не имеют <br>
            легального статуса
          </div>
        </div>
        <div class="info__column--65">
          <h3 class="info__title info__title--column">
            {{ 'Доказать собственность можно по любому из документов:' | typograf }}
          </h3>
          <ul class="info__list info__list--a4">
            <li>— решение органа власти о предоставлении земли под гараж</li>
            <li>— справка о выплате пая в гаражном кооперативе</li>
            <li>— решение предприятия о предоставлении гаража</li>
            <li>— решение собрания гаражного кооператива</li>
            <li>— техпаспорт на гараж</li>
            <li>— документы о подключении гаража к электросети</li>
            <li>— документы о наследстве</li>
            <li>— документы о приобретении гаража</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './article.styl'
import './info.styl'
import Loading from '@/components/Loading/Loading.vue'
import Layers from '@/components/Layers/Layers.vue'

export default {
  name: 'Article1',
  data () {
    return {
      observer: null,
      isLoading: false,
      titles: [
        'Миллионы владельцев гаражей по всей стране боялись сноса',
        'Дед умер в 2000 году. В память о нем и был куплен ЗАЗ',
        '«Гараж деда в любой момент могли взять и снести» <br> Алексей Рогов',
        '«Люди хотели зарегистрировать свою собственность, ведь она действительно их по праву» <br> глава Всероссийского общества автомобилистов Валерий Солодунов',
        '«Инициатива как нельзя более своевременная»',
        'Став полноправным владельцем, хозяин сможет использовать гараж и участок так, как считает нужным: подарить, продать, передать по наследству',
        'Гаражная амнистия продлится пять лет — до 2026 года',
        '«Для каждой семьи важно иметь дополнительный ресурс для гармоничного развития ребенка»'
      ]
    }
  },
  components: {
    Loading, Layers
  },
  methods: {
    disable () {
      const target = document.querySelector('#app')
      target.ontouchstart = (e) => {
        e.preventDefault()
      }
    },
    enable () {
      const target = document.querySelector('#app')
      target.ontouchstart = () => {
        return true
      }
    },
    onDone () {
      (document.getElementById('element-container')).classList.remove('-scale', '-no-blue')
      document.querySelector('html').classList.remove('-lock')
      this.enable()
    },

    onIntersection (entries) {
      entries.forEach((entry) => {
        entry.target.classList.toggle('-visible', entry.isIntersecting)

        if (entry.target.classList.contains('-visible')) {
          (document.getElementById('element-container')).classList.add('-scale')

          document.querySelector('html').classList.add('-lock')
          this.disable()
          this.isLoading = true

          setTimeout(() => {
            const layers = document.querySelectorAll('.bottom-layer')
            for (const layer of layers) {
              layer.classList.toggle('is-active')
            };

            this.$scrollTo('#element', 1800, { cancelable: false, offset: -60, onDone: this.onDone, onCancel: this.onDone })

            this.observer.disconnect()
          }, 1500)
        }
      })
    },

    initObserver () {
      this.observer = new IntersectionObserver(this.onIntersection, {
        root: null,
        threshold: 0.5
      })

      const nodes = document.querySelectorAll('.observer-move')

      nodes.forEach((node) => {
        this.observer.observe(node)
      })
    }
  },
  mounted () {
    const titles = []

    this.titles.forEach((item) => {
      titles.push(item.split(' '))
    })
    this.titles = titles

    this.initObserver()
  }
}
</script>

<style scoped lang="stylus">
.article-cir__21
  transition: all 1s ease-out
  transform none

#element-container
  transition: all 1s ease-out

  &.-no-blue
    background #f9f9f9

    .article-cir__21, .article__line3-1
      opacity 0

  #element-content
    transform-origin 50% 0
    transition: all 0.4s ease-out

  &.-scale
    #element-content
      transition: none
      transform scale(0.8)

.article__img1
  position: absolute
  width: 20rem
  left: 0
  top: 22rem

.article__img2
  position: absolute
  width: 22rem
  right: 0
  top: 65rem

.article__img3
  position: absolute
  width: 55rem
  right: 0
  top: 0
  z-index: 15

  @media(max-width: 950px)
    float: right

.article__img4
  position: absolute
  width: 55rem
  left: 0
  top: 0
  z-index: 15

.article__img5
  position: absolute
  width: 55rem
  right: 0
  top: 0
  z-index: 15

  @media(max-width: 950px)
    float: right

.article__line3
  position: absolute
  width: 38rem
  left: 0
  top: 4rem
  z-index: 4

.article__img6
  position: absolute
  width: 28rem
  right: 0
  top: 0

  @media(max-width: 950px)
    float: right
    width: 15rem
    margin: 0

.article__line4
  position: absolute
  width: 35rem
  right: 0
  top: 4rem
  z-index: 4

.article__img7
  position: absolute
  width: 29rem
  left: 0
  top: 85rem

  @media(max-width: 950px)
    display: none

.article__img8
  position: absolute
  width: 55rem
  left: 0
  top: 0
  z-index: 15

  @media(max-width: 950px)
    float: left

.article__line5
  position: absolute
  width: 38rem
  right: 0
  top: 4rem
  z-index: 4

.article__line2
  position: absolute
  width: 47rem
  right: 0
  top: 0
  z-index: 14

.article__line6
  position: absolute
  right: 3rem
  top: 0
  width: 85rem

.article__line3-1
  position: absolute
  right: 5rem
  top: -18rem
  width: 55.7rem
  z-index: 5
  transition: all 1s ease-out
  transition-delay .4s

  @media(max-width: 950px)
    display: none
</style>
